export default "__VITE_ASSET__sSJYB2z2__"